//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import {
  EditableBVSamplingProduct,
  EditableBVSamplingProductVariation,
} from '@campaigns/types/sampling/SamplingProductTypes';

// `satisfies` ties keys to real product/variation fields so typos and renames are caught at compile time
export const ProductDetailsFieldLabels = {
  brand: 'Product Brand',
  category: 'Product Category',
  description: 'Product Description',
  destinationGTIN: 'GTINs/UPCs/EANs for Syndication (optional)',
  fairMarketValue: 'Fair Market Value',
  imgUrl: 'Image',
  logisticsRef: 'Unique Product Code',
  name: 'Product Name',
  pdpUrl: 'Product URL (optional)',
  quantity: 'Quantity',
  shippingAvailabilityDate: 'Shipping Availability Date',
  targetCatalogProductId: 'Product ID',
  variantName: 'Name',
} as const satisfies Partial<
  Record<
    keyof EditableBVSamplingProduct | keyof EditableBVSamplingProductVariation,
    string
  >
>;
